import { Component } from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {LoadingService} from '../../services/loading.service';

@Component({
  selector: 'antm-loading-overlay',
  imports: [
    MatProgressSpinner
  ],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss',
})
export class LoadingOverlayComponent {

  constructor(
    public loadingService: LoadingService
  ) {
  }
}
